import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { CrystallisationDetailsSection } from "../../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownTypeOption } from "../../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DIAC } from "../../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import {
    getChooseAssetsToSellTable,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
} from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { BceAndPclsTaxYear } from "../../../../Common/SIPP/DrawdownDetails/BceAndPCLSTaxYear";
import { IllHealth } from "../../../../Common/SIPP/DrawdownDetails/IllHealth";
import { DrawdownCalculationAction } from "../../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { QuoteInstructionStore } from "../../../Store/Variable";
import { NewQuoteAction } from "../../../Actions/NewQuoteAction";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { PensionProtection } from "../../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ChooseAssetsToSellAssets } from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ assetsTable: getChooseAssetsToSellTable(this.props.data.PensionQuote) });
        if (
            !LessThanAge(55, JsonDateParser.toDate(this.props.data?.ClientDetails?.DateOfBirth)) &&
            !this.props.data?.PensionQuote?.DrawdownModel?.InstructionId
        ) {
            this.setState({ isLoading: true });
            const params = getQueryParameters();
            DrawdownCalculationAction.postDrawdown(
                this.props.data?.PensionQuote?.HierarchyId,
                null,
                (drawdownModel: DrawdownModel) => {
                    NewQuoteAction.getQuoteInstruction(params["id"]);
                    this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                }
            );
        }
    }

    private getComponentProps = (data: QuoteModel, onChange) => {
        return {
            data: data?.PensionQuote?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                    v,
                    data.PensionQuote,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType || QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.PensionQuote?.DrawdownModel?.DrawdownType;
        const _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.PensionQuote.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        NewQuoteAction.saveQuoteInstruction(1, _data, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data) {
        return (
            LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)) &&
            !data?.PensionQuote?.DrawdownModel?.InstructionId
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum =
            data?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.setState({ isLoading: true });
                        const params = getQueryParameters();
                        DrawdownCalculationAction.postDrawdown(
                            this.props.data?.PensionQuote?.HierarchyId,
                            null,
                            (drawdownModel: DrawdownModel) => {
                                NewQuoteAction.getQuoteInstruction(params["id"]);
                                this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                            }
                        );
                    }}
                />
            );
        }
        return (
            <WizardLinter
                status={EWizardLinterStatus.PleaseComplete}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.Npr)}
            >
                <h2>Drawdown details</h2>
                <PensionProtection
                    {...this.props}
                    onRef={(ref) => this.appendChild(ref)}
                    data={data?.PensionQuote}
                    onChange={(v) => this.onDataChange(onChange, v, data, "PensionQuote")}
                    process={ProcessType.Quote}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                />
                <BceAndPclsTaxYear
                    {...this.getComponentProps(data, onChange)}
                    process={ProcessType.Quote}
                    pensionProtection={data?.PensionQuote?.PensionProtection}
                />

                <DrawdownTypeOption
                    isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                    originType={
                        this.state.originType ||
                        QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType
                    }
                    {...this.getComponentProps(data, onChange)}
                    pensionProtection={data?.PensionQuote?.PensionProtection}
                />
                {data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                    <RegularCrystallisation
                        {...this.getComponentProps(data, onChange)}
                        process={ProcessType.Quote}
                        doCalculation={() => this.doCalculation()}
                    />
                )}

                {(data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Capped ||
                    data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Flexible) && (
                    <CrystallisationDetailsSection
                        isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                        modelData={this.props.data?.PensionQuote}
                        processType={ProcessType.Quote}
                        cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                        doCalculation={() => this.doCalculation()}
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                    />
                )}

                <LTABreakdownDetails
                    doCalculation={() => this.doCalculation()}
                    {...this.getComponentProps(data, onChange)}
                    process={ProcessType.Quote}
                    lessThan75={ageLessThan75}
                />

                <TaxFreeLumpSumPayment
                    process={ProcessType.Quote}
                    pensionProtection={data?.PensionQuote?.PensionProtection}
                    {...this.getComponentProps(data, onChange)}
                    lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                />

                {data?.PensionQuote?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                    <DIAC
                        {...this.getComponentProps(data, onChange)}
                        modelData={this.props.data?.PensionQuote}
                        existingAccount={false}
                    />
                )}
                <OAC
                    readonly={true}
                    type={SubAccountType.Npr}
                    onChange={(v) => {}}
                    data={{
                        OngoingAdviceCharge:
                            data?.PensionQuote?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                    }}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRef={(ref) => this.appendChild(ref)}
                />

                {showChooseAssetstoSell(data?.PensionQuote?.DrawdownModel, ChooseAssetsToSellFor.Drawdown) &&
                    !isImmediateTaxFreeLumpSum && (
                        <>
                            <hr />
                            <ChooseAssetsToSell
                                {...this.getComponentProps(data, onChange)}
                                tableKey={"PensionCommencementLumpSumAllocations"}
                            />
                            {!data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets && (
                                <ChooseAssetsToSellTable
                                    modelData={data?.PensionQuote?.DrawdownModel}
                                    data={
                                        data?.PensionQuote?.DrawdownModel?.PensionCommencementLumpSumAllocations || []
                                    }
                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                    tableData={this.state.assetsTable}
                                    onRef={(ref) => this.appendChild(ref)}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                                            { PensionCommencementLumpSumAllocations: v },
                                            data.PensionQuote,
                                            "DrawdownModel"
                                        );
                                    }}
                                    processType={ProcessType.Quote}
                                    reason={ChooseAssetsToSellFor.Drawdown}
                                />
                            )}
                        </>
                    )}
            </WizardLinter>
        );
    }
}
